import React from "react";
import { Route, Switch } from "react-router-dom";
import WhatsAppAccountList from "./container/whatsapp-accounts-list";

export default function WhatsAppAccountsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={WhatsAppAccountList} />
    </Switch>
  );
}